// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Search from '@/components/search';
import Table from '@/components/table';
import Pagination from '@/components/pagination';
import { useRouter } from 'next/router'
import DownloadService from '@/utils/download-service';
import Button from '@/components/button';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme'
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

const COLUMNS = [
    { "Model": "InvoiceList", "ColumnName": "InvoiceNumber", "Label": "Invoice Number", "Show": true, "IsRequired": true, "CellType": "text", "Order": 1, "Sortable": true, "IsActive": true },
    { "Model": "InvoiceList", "ColumnName": "Reference", "Label": "Reference", "Show": true, "IsRequired": true, "CellType": "text", "Order": 2, "Sortable": true, "IsActive": true },
    { "Model": "InvoiceList", "ColumnName": "TotalInclusive", "Label": "Total Incl Tax", "Show": true, "IsRequired": true, "CellType": "currency", "Order": 3, "Sortable": true, "IsActive": true },
    { "Model": "InvoiceList", "ColumnName": "InvoiceDate", "Label": "Date", "Show": true, "IsRequired": true, "CellType": "date", "Order": 4, "Sortable": true, "IsActive": true },
    { "Model": "InvoiceList", "ColumnName": "InvoiceStatusDescription", "Label": "Status", "Show": true, "IsRequired": true, "CellType": "status", "Order": 5, "Sortable": true, "IsActive": true }
];

function SageInvoiceList() {

    const router = useRouter();
    const { t, c } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const { data: tenantData } = useQuery(
        ['czTenant', t],
        () => Fetch.preLogin({ tenantID: t }),
        { enabled: !!t }
    );
    const tenant = tenantData?.HttpStatusCode === 200 && tenantData.Results?.length > 0 ? tenantData.Results[0] : null;

    const { data: invoicesData } = useQuery(
        ['czSageInvoices', t, c],
        () => Fetch.post({ url: '/CustomerZone/GetSageInvoices', params: { CustomerID: c }, tenantID: t, customerID: c, apiUrlOverride: tenant.API }),
        { enabled: !!tenant }
    );

    const [invoices, setInvoices] = useState<any[]>([]);
    const [totalResults, setTotalResults] = useState(0);

    useEffect(() => {
        if (tenantData && !tenant) {
            router.replace(`/customerzone?t=${t}&c=${c}`);
        }
    }, [tenantData]);

    useEffect(() => {
        if (invoicesData) {
            setInvoices(invoicesData.Results || []);
            setTotalResults(invoicesData.TotalResults || 0);
        }
    }, [invoicesData]);

    const [columnState] = useState(COLUMNS);
    const [searchVal, setSearchVal] = useState("");
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeFilterIds, setActiveFilterIds] = useState<any>({});
    const [searching, setSearching] = useState(false);

    const columns = React.useMemo(
        () => columnState.filter((column: any) => column.Show == true).map(function (column: any) {
            return Helper.getColumnObject(column);
        }),
        [columnState]
    );

    const updateActiveFilterIds = (newIds: any) => {
        setActiveFilterIds(newIds);
    };

    function setSort(field: any) {
        if (field != sortField) {
            setSortDirection('ascending');
        } else {
            if (sortDirection == 'ascending') {
                setSortDirection('descending');
            } else {
                setSortDirection('ascending');
            }
        }
        setSortField(field);
    }

    function exportInvoice(rowObj: any) {
        DownloadService.downloadFile("GET", `/CustomerZone/GetSageInvoiceDocument?externalID=${rowObj.ExternalID}`, null, true, false, (t as any), (c as any));
    }

    function exportCustomerStatement() {
        DownloadService.downloadFile("GET", `/CustomerZone/GetSageCustomerStatementDocument?customerID=${c}`, null, true, false, (t as any), (c as any));
    }

    if (!tenant) return null;

    return (
        <div className="list-container">

            <div className="row end">
                <div className="search-container">
                    <Search
                        placeholder="Search Invoice Number"
                        resultsNum={invoices.length}
                        filters={{}}
                        searchVal={searchVal}
                        setSearchVal={setSearchVal}
                        setActiveFilterIds={updateActiveFilterIds} />
                </div>
                <div className="disclaimer">
                    * Make sure popup blocker is disabled to successfully export invoices and statements
                </div>
                <div className="end">
                    <Button text="Get Statement" onClick={exportCustomerStatement} />
                </div>
            </div>

            <div className={"no-items" + (invoices.length == 0 ? " no-items-visible" : "")}>
                <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
                    <div className="loader"></div>
                </div>
                <img src="/quotes-box.svg" alt="Invoice Folder" />
                <h3>No invoices found</h3>
                <p>If you can't find an invoice, try another search</p>
                <img className="wave" src="/wave.svg" alt="wave" />
            </div>

            <div className={"table-container" + (invoices.length != 0 ? " table-container-visible" : "")}>
                <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
                    <div className="loader"></div>
                </div>
                <Table
                    actions={[{ text: "Export", function: exportInvoice }]}
                    columns={columns} data={invoices} setSort={setSort} sortField={sortField} sortDirection={sortDirection} />
            </div>
            <Pagination pageSize={pageSize} setPageSize={setPageSize} currentPage={currentPage} totalResults={totalResults} setCurrentPage={setCurrentPage} />

            <style jsx>{`
        .column { width: 100%; }
        .column-margin { margin-left: 24px; }
        .button-container { flex-shrink: 0; width: 10rem; }
        .button-container :global(.button){ margin-top: 0.5rem; }
        .row { display: flex; justify-content: space-between; }
        .end { align-items: flex-end; }
        .row.top-gap { margin-top: 2.5rem; }
        .search-container { width: 100%; }
        .search-container :global(.search) { width: 528px; }
        .disclaimer { width: max-content; font-style: italic; font-size: 0.8em; margin-right: 8px; color: ${colors.blueGreyLight}; }
        a { text-decoration: none; }
        .download { margin-right: 1rem; width: 3rem; }
      `}</style>
        </div>
    );

}

export default SageInvoiceList;

export const Route = createFileRoute('/customerzone/sageinvoicelist')({ component: SageInvoiceList })
